var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8607 8.95631C14.8607 14.3351 9.35149 17.6489 8.2066 18.2801C8.14318 18.3151 8.07193 18.3334 7.99949 18.3334C7.92706 18.3334 7.85581 18.3151 7.79238 18.2801C6.64664 17.6489 1.13916 14.3351 1.13916 8.95631C1.13916 4.66833 3.71195 1.66675 7.99992 1.66675C12.2879 1.66675 14.8607 4.66833 14.8607 8.95631Z",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56934 8.52755C4.56934 9.43734 4.93075 10.3099 5.57407 10.9532C6.21739 11.5965 7.08992 11.9579 7.99972 11.9579C8.90951 11.9579 9.78204 11.5965 10.4254 10.9532C11.0687 10.3099 11.4301 9.43734 11.4301 8.52755C11.4301 7.61775 11.0687 6.74522 10.4254 6.1019C9.78204 5.45858 8.90951 5.09717 7.99972 5.09717C7.08992 5.09717 6.21739 5.45858 5.57407 6.1019C4.93075 6.74522 4.56934 7.61775 4.56934 8.52755V8.52755Z",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.605eec2e6b913737080d8a486fdc3d18.svg";
export { ForwardRef as ReactComponent };